import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

const useEvaluateCanTranslate = () => {
  const { control } = useFormContext();

  const [titleEs, descEs, titleEn, descEn] = useWatch({
    control,
    name: [
      CPropertyFormKeys.seo_title_es_property,
      CPropertyFormKeys.seo_description_es_property,
      CPropertyFormKeys.seo_title_en_property,
      CPropertyFormKeys.seo_description_en_property
    ]
  });

  return useMemo(() => {
    const canEsToEn = Boolean(titleEs && descEs);
    const canEnToEs = Boolean(titleEn && descEn);

    return {
      canEsToEn,
      canEnToEs,
      canTranslate: canEsToEn || canEnToEs
    };
  }, [titleEs, descEs, titleEn, descEn]);
};

export default useEvaluateCanTranslate;
